
import { Component, Prop, Vue } from 'vue-property-decorator';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';

@Component({ components: { CustomDialog, CustomButton } })
export default class PurchaseWindowInfoDialog extends Vue {
  @Prop({ type: String, default: '21.5rem' }) readonly width!: string;

  @Prop(Boolean) readonly closeButton!: boolean;
}
